import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createRaiseOutbound } from '../../../../api/outbound/pokerOutbounds';
import { useSocketSend } from '../../../../context/webSocket/webSocketContext';
import { getShortRenderedValueStr } from '../../../../utils/numberPrecisionUtils';
import { Button } from '../../pixiComponents/button';
function getActionLabel(betSliderAmount, isSliderAtMax, myNumChips) {
    if (!isSliderAtMax) {
        return 'RAISE TO';
    }
    if (betSliderAmount >= myNumChips) {
        return 'ALL-IN';
    }
    return 'BET POT';
}
export const PixiRaiseButton = ({ betSliderAmount, bounds, myTurnProperties }) => {
    const socketSend = useSocketSend();
    const onClickRaise = useCallback(() => {
        const raiseAmountForOutbound = betSliderAmount - (myTurnProperties.betTotalAmountToCall - myTurnProperties.myTotalBetAmount);
        socketSend(createRaiseOutbound(myTurnProperties.betSequenceNumber, raiseAmountForOutbound));
    }, [
        betSliderAmount,
        myTurnProperties.betSequenceNumber,
        myTurnProperties.betTotalAmountToCall,
        myTurnProperties.myTotalBetAmount,
        socketSend
    ]);
    const isSliderAtMax = betSliderAmount >= myTurnProperties.betSliderMaxAmount;
    return (_jsx(Button, { pixiObjectData: { type: 'raise-button' }, onClick: onClickRaise, labelProperties: {
            label: getActionLabel(betSliderAmount, isSliderAtMax, myTurnProperties.myNumChips),
            bitmapTextStyleType: 'button-label',
            labelPixiDataType: 'raise-button-label'
        }, subLabelProperties: {
            label: getShortRenderedValueStr(betSliderAmount + myTurnProperties.myNumChipsThisPhase),
            bitmapTextStyleType: 'button-sub-label',
            labelPixiDataType: 'raise-button-sub-label'
        }, bounds: bounds, accentColor: 'green' }));
};
